import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  version: "1.1",
  id: "Capa_1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 281.232 281.232",
  style: {"enable-background":"new 0 0 281.232 281.232"},
  "xml:space": "preserve"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", null, [
  /*#__PURE__*/_createElementVNode("path", {
    style: {"fill":"#010002"},
    d: "M231.634,79.976v-0.751C231.634,30.181,192.772,0,137.32,0c-31.987,0-57.415,9.018-77.784,22.98\n\t\tc-11.841,8.115-12.907,25.906-4.232,37.355l6.326,8.349c8.675,11.444,24.209,12.532,36.784,5.586\n\t\tc11.46-6.331,23.083-9.758,34-9.758c18.107,0,28.294,7.919,28.294,20.75v0.375c0,16.225-15.469,39.411-59.231,43.181l-1.507,1.697\n\t\tc-0.832,0.936,0.218,13.212,2.339,27.413l1.741,11.58c2.121,14.201,14.065,25.71,26.668,25.71s23.839-5.406,25.08-12.069\n\t\tc1.256-6.668,2.268-12.075,2.268-12.075C199.935,160.882,231.634,127.513,231.634,79.976z"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    style: {"fill":"#010002"},
    d: "M118.42,217.095c-14.359,0-25.993,11.64-25.993,25.999v12.14c0,14.359,11.64,25.999,25.993,25.999\n\t\th22.322c14.359,0,25.999-11.64,25.999-25.999v-12.14c0-14.359-11.645-25.999-25.999-25.999H118.42z"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("g", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("g", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("g", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("g", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("g", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("g", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("g", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("g", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("g", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("g", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("g", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("g", null, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("g", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("g", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("g", null, null, -1)
const _hoisted_18 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5,
  _hoisted_6,
  _hoisted_7,
  _hoisted_8,
  _hoisted_9,
  _hoisted_10,
  _hoisted_11,
  _hoisted_12,
  _hoisted_13,
  _hoisted_14,
  _hoisted_15,
  _hoisted_16,
  _hoisted_17
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_18))
}
export default render